import {
  RECT_VARIANT,
  XYChartSeriesWithDatapoints,
} from '../types/xy-chart-internals.js';

export const getFallbackValueAccessor = (
  series: XYChartSeriesWithDatapoints,
) => {
  return series.type === RECT_VARIANT ? 'value' : 'x0';
};
